<template>
  <v-sheet class="pb-4">
    <v-sheet v-if="schedule">
      <schedule-item
        v-for="(item, k) in schedule.items"
        :key="k"
        :item="item"
        :item_id="k"
        :availableDays="availableDays"
      ></schedule-item>
    </v-sheet>
    <v-btn @click="addItem" class="mt-4 ml-4">{{
      $t("scheduleItemsAdd")
    }}</v-btn>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import ScheduleItem from "@/components/ScheduleItem.vue";

export default {
  name: "ScheduleItems",

  data() {
    return {
      availableDays: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },

  computed: {
    ...mapGetters(["schedule"]),
  },

  components: {
    ScheduleItem,
  },

  methods: {
    addItem() {
      this.schedule.items.push({
        begin: "",
        breaks: [],
        day_types: [],
        duration: null,
        end: "",
        overlap: false,
        pricing: [],
        schedule: null,
      });
    },
  },
};
</script>
